module.exports = __webpack_public_path__ + "img/top-card-kids.748e84b3.png";